// extracted by mini-css-extract-plugin
module.exports = {"alert-root":"style_alert-root__bxlH8"};